import { IJBPPlanning } from '../../models/IJBPPlanning'

export const getIsCollapsedCategory = (data: IJBPPlanning[], fyear: number) => {
  const filteredData = data.filter(
    (el) => el.FYear === fyear && el.SubCategory === 'jbp-overall' && !!el.IsCollapsed
  )
  return !!filteredData.length
}
